export const options = [
	{ label: '% de Descuento', value: 'percentage' },
	{ label: 'Monto Fijo', value: 'permanent' },
];

export const typeDisscount = {
	percentage: 'percentage',
	permanent: 'permanent',
};
